<template>
  <section class="content" >
    <div class="row center-block">
      <!--      <h2>Data tables</h2>-->
      <div class="col-md-12 row-rm-padding">
        <div class="box">
          <div class="box-header">
          </div>
          <!-- /.box-header -->
          <div class="box-body">
            <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
              <div class="row">
                <div class="col-sm-12">
                  <div id="example1_length" class="dataTables_length">
                    <div>
                      <button class="btn primary-btn-my" style="float: right;margin-bottom: 15px;margin-left: 15px;" @click="activeModal = true">Download Excel</button>
                      <sync-loader style="float: right;" :loading="orderListLoading" :color="'#FECD2F'" :size="'10px'" :width="'5px'" :margin="'2px'"></sync-loader>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table aria-describedby="example1_info" role="grid" id="tableData"
                         class="table table-bordered table-striped dataTable">
                    <thead>
                    <tr role="row">
                      <th aria-label="Rendering engine: activate to sort column descending" aria-sort="ascending"
                          style="width: 10%" colspan="1" rowspan="1" aria-controls="example1" tabindex="0"
                          class="sorting_asc">Date
                      </th>
                      <th aria-label="Browser: activate to sort column ascending" style="width: 20%;" colspan="1"
                          rowspan="1" aria-controls="example1" tabindex="0" class="sorting">User Name
                      </th>
                       <th aria-label="Browser: activate to sort column ascending" style="width: 20%;" colspan="1"
                          rowspan="1" aria-controls="example1" tabindex="0" class="sorting">Org. Name
                      </th>
                      <th aria-label="CSS grade: activate to sort column ascending" style="width: 10%;" colspan="1"
                          rowspan="1" aria-controls="example1" tabindex="0" class="sorting">Supervisor Name
                      </th>
                       <th aria-label="CSS grade: activate to sort column ascending" style="width: 10%;" colspan="1"
                          rowspan="1" aria-controls="example1" tabindex="0" class="sorting">Distributor Name
                      </th>
                       <th aria-label="CSS grade: activate to sort column ascending" style="width: 10%;" colspan="1"
                          rowspan="1" aria-controls="example1" tabindex="0" class="sorting">Distributor Email
                      </th>
                      <th aria-label="CSS grade: activate to sort column ascending" style="width: 10%;" colspan="1"
                          rowspan="1" aria-controls="example1" tabindex="0" class="sorting">Item Total
                      </th>
                      <th aria-label="CSS grade: activate to sort column ascending" style="width: 10%;" colspan="1"
                          rowspan="1" aria-controls="example1" tabindex="0" class="sorting">Status
                      </th>
                      <th style="width: 4%;" colspan="1" rowspan="1" tabindex="0">Actions</th>
                    </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>

     <!-- ================== View Card model ================== -->
    <md-dialog :md-active.sync="editModal" class="model-show-new">
      <md-dialog-title class="model-title modal-width-100">Cart Data
        <a style="float: right;cursor: pointer;" class="md-primary" @click="editModal = false">
          <md-icon class="close-btn" style="font-size: 18px !important;">close
          </md-icon>
        </a>
      </md-dialog-title>
        <form class="from-padding modal-width-100">
          <div class="md-layout md-gutter">
             <div class="cart_list" v-for="(item, index) in ItemList" :key="index">
               <div class="item_image_cart">
                 <img v-bind:src='item.product_details.thumbnail_medium'/>
               </div>
               <div class="item_data_cart">
                 <p class="pr_title">{{item.product_details.name}}</p>
                 <div  v-for="(item, index) in item" :key="index">
                  <p class="pr_datas" v-if="item != null && index != 'product_id' && index != 'id' && index != 'product_details' && index != 'product_description' && index != 'product_type_id' && index != 'qty' && index != 'status' && index != 'modify'  && index != 'color'   ">
                    {{convertToString(index) + ' = ' + item}}
                  </p>
                </div>
                  <p class="pr_datas">
                      Color = {{item.color.name}}
                  </p>
               </div>
               <div class="item_data_qty">
                 <p>Quantity</p>
                 <p class="item_qq">{{item.qty}}</p>
               </div>
             </div>
          </div>
        </form>
      <md-dialog-actions class="model-foot">
      </md-dialog-actions>
    </md-dialog>
    <!-- ================== User Active model ================== -->
     <md-dialog :md-active.sync="activeModal" class="model-show-new">
      <md-dialog-title class="model-title modal-width-100">Download Excel
        <a style="float: right;cursor: pointer;" class="md-primary" @click="activeModal = false">
          <md-icon class="close-btn" style="font-size: 18px !important;">close
          </md-icon>
        </a>
      </md-dialog-title>
      <div class="from-padding modal-width-100">
          <div class="error-acction" style="background-color: #ffb10052;"><p style='margin: 0;'>
              If you need to download all the data click <b>Download Excel</b> button.
            </p></div>
            <div class="date_picker" v-if = "renderComponent">
                <date-range-picker
                  ref="picker"
                  id="daterange"
                  :opens="opens"
                  :locale-data="{ firstDay: 1, format: 'yyyy-mm-dd'}"
                  :append-to-body='true'
                  :singleDatePicker="singleDatePicker"
                  :showWeekNumbers="showWeekNumbers"
                  :showDropdowns="showDropdowns"
                  :autoApply="autoApply"
                  v-model="dateRange"
                  :linkedCalendars="linkedCalendars"
                >
                </date-range-picker>
            </div>
          <md-field>
            <label class="lable-fileds">Distributors</label>
            <md-select v-model="searchData.distributor" name="Distributors" class="organization_id" id="Distributors">
              <md-option value="">None</md-option>
              <md-option v-for="item in getDistributorsList" v-bind:key="item.id" :value="item.id" >
                {{item.name}}
              </md-option>
            </md-select>
          </md-field>
      </div>
       <div class="custom-modal-footer-spaces"></div>

       <div class="custom-modal-footer-container">
         <button type="button" class="btn primary-btn-my custom-modal-footer-items" @click="genarateOrderListPDF">
           Download Excel
         </button>
         &nbsp;&nbsp;
         <button type="button" class="btn default_btn-my custom-modal-footer-items" @click="clearFilterData">
           Clear filter
         </button>
       </div>
    </md-dialog>
  </section>
</template>
<script>

  import $ from 'jquery'
  // Require needed datatables modules
  require('datatables.net')
  require('datatables.net-bs')
  var SyncLoader = require('vue-spinner/src/SyncLoader')

  // vue validations
  import {validationMixin} from 'vuelidate'
  import config from '../../../config'
  import Vue from 'vue'
  var moment = require('moment')
  import api from '../../../api'
  import InputColorPicker from 'vue-native-color-picker'

  import DateRangePicker from 'vue2-daterange-picker'
  // you need to import the CSS manually
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
    name: 'ProductView',
    components: {
      'SyncLoader': SyncLoader,
      'v-input-colorpicker': InputColorPicker,
      DateRangePicker
    },
    mixins: [validationMixin],
    data() {
      return {
        datatable: null,
        active: false,
        editModal: false,
        ItemList: [],
        getDistributorsList: [],
        orderListLoading: false,
        activeModal: false,
        searchData: {
          startDate: '',
          endDate: '',
          distributor: ''
        },
        renderComponent: true,
        dateRange: {},
        direction: 'ltr',
        separator: ' - ',
        opens: 'right',
        linkedCalendars: true,
        autoApply: false,
        showDropdowns: true,
        showWeekNumbers: true,
        singleDatePicker: false,
        customRangeLabel: 'Custom Range',
        firstDay: 0
      }
    },
    mounted() {
      // clear new modal
      this.$nextTick(() => {
        this.initDatatables()
        this.initJqueryMethods()
        this.setDistributorsList()
      })
    },

    methods: {
      setDistributorsList() {
        api
          .request('get', '/admin/distributors/select')
          .then(response => {
            this.getDistributorsList = response.data.data
          })
      },
      genarateOrderListPDF() {
        this.orderListLoading = true
        var ref = this
        var endDate = ''
        var startDate = ''
        if (this.dateRange.endDate && this.dateRange.startDate) {
          endDate = moment(this.dateRange.endDate).format('YYYY-MM-DD')
          startDate = moment(this.dateRange.startDate).format('YYYY-MM-DD')
        }
        api.request('get', '/admin/orders/datatable/exportData?endDate=' + endDate + '&startDate=' + startDate + '&distributor=' + this.searchData.distributor)
        .then(response => {
          if (response.data.status === 'success') {
            ref.downloadOrders()
          } else {
            alert('error while downloading')
          }
        }).catch(error => {
          this.orderListLoading = false
          alert(error)
        })
      },
      clearFilterData() {
        var ref = this
        ref.dateRange = {}
        ref.searchData.distributor = ''
        ref.forceRerender()
      },
      forceRerender () {
        // remove the my-component component from the DOM
        this.renderComponent = false
        this.$nextTick(() => {
          // add my-component component in DOM
          this.renderComponent = true
        })
      },
      downloadOrders() {
        var ref = this
        api.httpRequestCore({
          method: 'get',
          url: 'https://smartapprcp.s3.ap-southeast-1.amazonaws.com/rcp_docs/other/product/ProductRequests.csv',
          responseType: 'arraybuffer'
        })
          .then(response => {
            ref.forceFileDownload(response)
          })
          .catch(error => {
            ref.orderListLoading = false
            alert(error)
          })
      },
      forceFileDownload(response) {
        this.orderListLoading = false
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'ProductRequests.csv') // or any other extension
        document.body.appendChild(link)
        link.click()
      },
      convertToString(Text) {
        var txt = Text.toLowerCase().replace(/_/g, ' ')
        var arr = txt.split(' ')
        var newArr = []
        arr.forEach(data => {
          newArr.push(data.charAt(0).toUpperCase() + data.slice(1))
        })
        return newArr.join(' ')
      },

      initDatatables() {
        this.dataTable = $('#tableData')
          .on('xhr.dt', function (e, settings, json, xhr) {
            json.recordsTotal = json.data.original.recordsTotal
            json.draw = json.data.original.draw
            json.recordsFiltered = json.data.original.recordsFiltered
          })
          .DataTable({
            serverSide: true,
            processing: true,
            responsive: true,
            paging: true,
            lengthChange: true,
            searching: true,
            ordering: true,
            info: true,
            autoWidth: false,
            search: {
              'caseInsensitive': false
            },

            order: [[0, 'desc']],
            ajax: {
              url: config.serverURI + '/admin/orders/datatable',
              type: 'get',
              contentType: 'application/json; charset=UTF-8',
              dataSrc: 'data.original.data',
              headers: {
                'Authorization': 'Bearer ' + Vue.auth.getToken()
              }
            },
            columnDefs: [
              {
                'orderable': true,
                'targets': [0],
                'responsivePriority': 0,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  return '<span>' + full.date + '</span>'
                }
              },
              {
                'orderable': true,
                'targets': [1],
                'responsivePriority': 1,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  return '<span>' + full.user_name + '</span>'
                }
              },
              {
                'orderable': true,
                'targets': [2],
                'responsivePriority': 2,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  return '<span>' + full.organization + '</span>'
                }
              },
              {
                'orderable': true,
                'targets': [3],
                'responsivePriority': 3,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  return '<span>' + full.supervisor_name + '</span>'
                }
              },
              {
                'orderable': true,
                'targets': [4],
                'responsivePriority': 4,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  if (!full.distributor_name) {
                    return '<span class="badge badge-warning">N/A</span>'
                  }
                  return '<span>' + full.distributor_name + '</span>'
                }
              },
              {
                'orderable': true,
                'targets': [5],
                'responsivePriority': 5,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  if (!full.distributor_email) {
                    return '<span class="badge badge-warning">N/A</span>'
                  }
                  return '<span>' + full.distributor_email + '</span>'
                }
              },
              {
                'orderable': true,
                'targets': [6],
                'responsivePriority': 6,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  return '<span>' + full.order_items.length + '</span>'
                }
              },
              {
                'orderable': true,
                'targets': [7],
                'responsivePriority': 7,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  if (full.status === 'Fully Approved') {
                    return '<span class="badge bg-green">Fully Approved</span>'
                  } else if (full.status === 'Partially Approved') {
                    return '<span class="badge bg-blue">Partially Approved</span>'
                  } else if (full.status === 'Pending') {
                    return '<span class="badge bg-yellow">Pending</span>'
                  } else if (full.status === 'Rejected') {
                    return '<span class="badge bg-red">Rejected</span>'
                  }
                  return '<span class="badge badge-warning">N/A</span>'
                }
              },
              {
                'orderable': false,
                'targets': [8],
                'responsivePriority': 8,
                'searchable': false,
                'className': 'details-control',
                'render': function (data, type, full, meta) {
                  if (full.status === 'Rejected' || full.status === 'Pending') {
                    return '<button type="button" data-id= ' + full.id + ' class="btn btn-info btn-sm btn-modal-edit"><i class="fa fa-eye"></i></button>'
                  } else {
                    return '<button type="button" data-id= ' + full.id + ' class="btn btn-info btn-sm btn-modal-edit"><i class="fa fa-eye"></i>' +
                      '</button>&nbsp;<button data-id= ' + full.id + ' type="button" class="btn btn-notifi btn-sm btn-modal-resend"><i class="fa fa-paper-plane"></i></button>'
                  }
                }
              }
            ]
          })
      },

      initJqueryMethods() {
        var ref = this
        // edit modal open
        $('#tableData tbody').on('click', 'td.details-control button.btn-modal-edit', function () {
          var id = $(this).attr('data-id')
          ref.showEditModal(id)
        })
         // Resend modal open
        $('#tableData tbody').on('click', 'td.details-control button.btn-modal-resend', function () {
          var id = $(this).attr('data-id')
          ref.resendEmail(id)
        })
      },

      resendEmail(id) {
        this.ItemList = []
        api.request('get', '/admin/orders/resend/' + id)
          .then(response => {
            if (response.status === 200) {
               // eslint-disable-next-line no-undef
              toast.fire({icon: 'success', title: 'Email sent successfuly'})
            } else {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
          }).catch(error => {
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
          })
      },

      showEditModal(id) {
        api.request('get', '/admin/orders/show/' + id)
          .then(response => {
            if (response.status === 200) {
              // this.editForm = response.data.data
              this.ItemList = response.data.data.order_items
              // var foo = {one: 1, two: 2, three: 3}
              // for (var key in itemdata[0]) {
              //   console.log(key + '=' + itemdata[0][key])
              // }
              this.editModal = true
            } else {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
          }).catch(error => {
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
          })
      }
    }
  }
</script>

<style>

  @import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

  table.dataTable thead .sorting:after,
  table.dataTable thead .sorting_asc:after,
  table.dataTable thead .sorting_desc:after {
    font-family: 'FontAwesome';
  }

  table.dataTable thead .sorting:after {
    content: '\f0dc';
  }

  table.dataTable thead .sorting_asc:after {
    content: '\f0dd';
  }

  table.dataTable thead .sorting_desc:after {
    content: '\f0de';
  }


</style>



// WEBPACK FOOTER //
// ProductRequest.vue?23663c5a